import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "beautix.cookie.consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const set = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Zgoda na pliki cookies"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 bg-white border border-[var(--beautix-line)] shadow-[0_20px_50px_-15px_rgba(0,0,0,0.15)] rounded-2xl p-5 md:p-6 fade-up"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-[var(--beautix-blush)] text-[var(--beautix-pink)] flex items-center justify-center shrink-0">
          <Cookie className="w-4 h-4" strokeWidth={1.5} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-[var(--beautix-ink)] mb-1">
            Używamy plików cookies
          </p>
          <p className="text-xs text-[var(--beautix-muted)] leading-relaxed">
            Ta strona korzysta z ciasteczek do celów statystycznych i poprawy
            komfortu użytkowania.{" "}
            <Link
              to="/polityka-prywatnosci"
              className="link-underline text-[var(--beautix-pink)]"
            >
              Dowiedz się więcej
            </Link>
            .
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => set("accepted")}
              data-testid="cookie-accept"
              className="bg-[var(--beautix-pink)] hover:bg-[var(--beautix-pink-dark)] text-white text-xs px-4 py-2 rounded-full font-medium tracking-wide"
            >
              Akceptuję wszystkie
            </button>
            <button
              type="button"
              onClick={() => set("essential")}
              data-testid="cookie-essential"
              className="border border-[var(--beautix-line)] text-[var(--beautix-ink)] text-xs px-4 py-2 rounded-full font-medium tracking-wide hover:bg-[var(--beautix-cream)]"
            >
              Tylko niezbędne
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={() => set("dismissed")}
          aria-label="Zamknij"
          className="text-[var(--beautix-muted)] hover:text-[var(--beautix-ink)] shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
